<template>
  <div class="followup">
    <div class="row no-gutters followup-main">
      <div class="col-10 offset-1">
        <div class="row no-gutters mt-3">
          <div
            class="col-12 offset-0"
            v-bind:class="{
              'col-lg-10 offset-lg-1 col-xl-10 offset-xl-1': !this.row,
            }"
          >
            <div class="row no-gutters mb-4">
              <div class="col-12">
                <div class="row no-gutters">
                  <div class=" col-12 offset-0">
                    <div class="m-card text-center">
                      <div class="row no-gutters">
                        <div class="col-lg-8 offset-lg-2">
                          <h1 class="o-heading o-heading--xl">
                            Elenco Follow-up
                          </h1>
                         <p >In questa sezione troverai visite ed esami di approfondimento o follow-up che ti sono stati prescritti a seguito delle prestazioni che hai effettuato presso le nostre sedi.</p>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div v-if="referti.length === 0 && !loading" class="row no-gutters mt-5 mb-5">
              <div class="col-12">
                <div class="row no-gutters">
                  <div class=" col-12 offset-0">
                    <div class="m-card text-center">
                      <div class="row no-gutters">
                        <div class="col-lg-8 offset-lg-2">
                          <p ><b>Nessun follow-up trovato.</b></p>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


           <!-- <app-list-pager v-if="!jit && referti.length > 0"  item-type-label="Follow-up" :loading="this.loading" :pages="this.pages" :count="this.total" :rpp="this.rpp" :page="this.page" @onPageChange="changePage($event)"></app-list-pager>
-->
            <div class="row no-gutters mb-2 column-header  d-md-flex" v-if="false">
              <div class="row col-12">
              <span class="d-none d-sm-block col-5 col-xxl-6 text-left ">&nbsp;</span>
              <span class="col-12 col-sm-4 text-left ">Prestazione da eseguire preferibilmente </span>
              <span class="d-none d-sm-block col-3 col-xxl-2 text-left ">&nbsp;</span>
              </div>
            </div>

            <app-follow-up-card v-for="ref in referti" v-bind:key="ref.id" :data="ref"  @DownloadFile="checkService" @StartBooking="startBooking" @HideItem="hideItem" :show-book="ref.DataRef != null && ref.DataRef >= '2026-02-01'">


            </app-follow-up-card>

            <app-list-pager v-if="!jit  && referti.length"  item-type-label="Follow-up" :loading="this.loading" :pages="this.pages" :count="this.total" :rpp="this.rpp" :page="this.page" @onPageChange="changePage($event)"></app-list-pager>


          </div>
        </div>
      </div>
    </div>
    <div v-if="referti.length > 0" class="row no-gutters footerDisclaimer  ">
      <div class="col-10 offset-1">
        <div class="col-12">

              <div class="m-card text-justify">
                <div class="row no-gutters">
                  <div class="ml-1 mr-1">
                    <p >Per l'identificazione dei follow-up CDI si è avvalsa dell’ausilio di un sistema di intelligenza artificiale.
                      Le presenti indicazioni non sostituiscono in alcun modo il giudizio clinico del professionista medico.
                      Il paziente deve attenersi esclusivamente al referto medico e alle prescrizioni fornite dal professionista sanitario in merito alla definizione del percorso diagnostico e terapeutico.
                    </p>
                  </div>


            </div>
          </div>
        </div></div>
    </div>
    <b-modal ref="hideMenu"
             id="hideMenu"
             centered
             modal-class="o-modal"
             content-class="o-modal__content o-modal__content-followup"
             header-class="o-modal__header"
             dialog-class="o-modal__dialog"
             body-class="o-modal__body o-modal__body--response "
             :cancel-disabled=true
             :hide-footer=true
             size="lg"
    >
      <p class="mt-3">Sei sicuro di non voler più visualizzare il tuo follow-up?</p>

      <b-form-group class="text-left">
        <b-form-checkbox
            :checked="checkboxSelected === '1'"
            @change="handleCheckbox('1')"
            name="checkbox1"
        >Si, ho già effettuato la prenotazione</b-form-checkbox>
        <b-form-checkbox
            :checked="checkboxSelected === '2'"
            @change="handleCheckbox('2')"
            name="checkbox2"
        >Si, per altra motivazione</b-form-checkbox>
      </b-form-group>

      <b-form-input
          v-if="checkboxSelected === '2'"
          v-model="inputValue"
          maxlength="255"
          placeholder="Inserisci qui la motivazione "
          class="mt-2 custom-placeholder"
      ></b-form-input>
      <div v-if="checkboxSelected === '2'" class="d-flex justify-content-end mt-1"
          >
        <small class="text-muted">{{inputValue? inputValue.length:0 }}/255</small>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <b-button
            class="text-uppercase mr-2"
            variant="primary"
            :disabled="!(checkboxSelected === '1' || (checkboxSelected === '2' && inputValue && inputValue.length > 0))"
            @click="sendHide"
        >OK</b-button>
        <b-button
            class="text-uppercase"
            variant="primary"
            @click="closeHideMenu"
        >Annulla</b-button>
      </div>
   </b-modal>
  </div>
</template>
<style scoped>
.followup {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.followup-main {
  flex: 1 1 auto;       /* Occupa tutto lo spazio disponibile */
  /* overflow-y: auto;  // opzionale se vuoi scroll interno */
}

.footerDisclaimer {
  flex-shrink: 0;       /* Non si restringe mai */
  /* Altri stili di tua scelta */
}
</style>
<style>
.column-header {
  padding: 0.5rem 1.6rem;
  padding-top: 1rem !important;
}
.custom-placeholder::placeholder {
  color: rgba(7, 75, 125, 0.55);
  opacity: 1;
}
.o-modal__content-followup {
  background-color: rgba(206, 224, 237, 0.27);
}

.o-main-height {
  height: calc(100vh - 220px);

}
.o-footer__forcedown {
  position: absolute;
}
@media (max-width: 767px) {
  .o-footer__forcedown {
    display: none !important;
  }
}
.btn-small{
  max-width: 50px;
  padding-left: 13px;
  padding-right: 15px;
}
</style>
<script>

import apiAxios from "@/libs/apiAxios";
import AppListPager from "@/components/molecules/AppListPager";
import AppFollowUpCard from "@/components/molecules/AppFollowUpCard.vue";
import router from "@/router";


export default {
  name: "followup",
  components: {AppFollowUpCard, AppListPager },

  created() {
    if (this.hasState()) {
      this.restoreState();
    }
    else {
      this.getPageFromApi(0);
    }
  },
  data() {
    return {
      loading: true,
      pages: 0,
      page: 0,
      total: 0,
      rpp: 10,
      jit: false,
      referti: [],
      selected: null,
      options: [],
      row: false,
      line: true,
      service: 'followup',
      checkboxSelected: null, // '1' o '2'
      inputValue: '',
      itemToHide: null,
    };
  },

  methods: {
    updateRow(e) {
      this.row = e;
    },
    handleCheckbox(val) {
      this.checkboxSelected = val;
    },
    storeState(data) {
      console.log(data);
      const o={
        page: this.page+1,
        pageSize: this.rpp,
        total: this.total,
        pages: this.pages,
        referti: this.referti,
        selected: data._id
      }
      try {
        localStorage.setItem("followup", JSON.stringify(o));
      } catch (e) {
        console.error("Error storing followup state:", e);
      }

    },
    restoreState() {
      if (localStorage.getItem("followup")) {
        try {
          const o = JSON.parse(localStorage.getItem("followup"));
          localStorage.removeItem("followup");
          this.loadData(o);
        } catch (e) {
          console.error("Error restoring followup state:", e);
        }
      }
    },
    hasState() {
      return localStorage.getItem("followup") !== null;
    },
    loadData(data) {
      console.log(data);
      this.data = data;
      this.rpp = data.pageSize;
      this.referti = data.referti;
      this.total = data.total;
      this.pages = data.pages;
      this.loading = false;
      this.page = data.page-1;
      this.options = [];
      

      this.selected = ('selected' in data) ? data.selected : null;

      if (this.selected != null) {
        const found = this.referti.find((r) => r._id === this.selected);
        if (found) {
          console.log("Downloading file for referto", found);
          this.checkService(found);
        }
      }
    },

    getPageFromApi(page) {
      this.loading = true;
      apiAxios
        .get(`/followup?page=${page}&pageSize=${this.rpp}`)
        .then((response) => {
          this.loadData(response.data.FollowupResult);
        })
        .catch((error) => {
          console.error("Error fetching followup data:", error);
          this.loading = false;
        });
    },

    sendHide() {
      if (!this.itemToHide) {
        return;
      }

      let x=null;
      let y = null;
      if (this.checkboxSelected === '1') {
        x='done'
        y='';

      } else if (this.checkboxSelected === '2') {
        x='ignore'
        y=this.inputValue;
      }

      const data={
        action: x,
        reason: y,
        id: this.itemToHide._id,
        tipo: this.itemToHide.tipologia,
      };

      console.log(this.itemToHide);

      apiAxios.post(`/followup/setHidden`, data)
          .then((response) => {
            console.log("Followup hidden/removed", response);
            this.getPageFromApi(this.page);
          })
          .catch((error) => {
            console.error("Error hiding/removing followup:", error);
          });
      this.itemToHide = null;
      this.closeHideMenu();
    },

    changePage(p) {
      this.getPageFromApi(p);
    },
    checkService(data){

      let userdata=this.$store.getters["dateUser/UserData"];
      if (userdata.validation===0 || userdata.validation===1){
        router.push('/unauthorized');
        return;
      }

      console.log("checkService",data);
      const _this=this;
      apiAxios.get('/fatture/enabled')
          .then(response => {
            if (response.data.IsEnabledResult)
            {
              return this.pdfOnNewWindow(data.RefertoID,data.Episodio,data.Sorgente,data.hash);
            }
            else {
              _this.storeState(data);
              router.push('confermaAccessoApp?service=fatref&goto=followup');
            }
          })
          .catch(error=>{
            console.log(error);
          });
      return false;

    },
    book() {
      alert('booking')
    },
    hideItem(data) {
      console.log(data);
      this.checkboxSelected=null;
      this.inputValue=null;
      this.itemToHide=data;
      this.$refs['hideMenu'].show();
    },
    closeHideMenu() {
      this.itemToHide=null;
      this.$refs['hideMenu'].hide();
    },

    downloadFile(blob, fileName){
      const link = document.createElement('a');
      // create a blobURI pointing to our Blob
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      // some browser needs the anchor to be in the doc
      document.body.append(link);
      link.click();
      link.remove();
      // in case the Blob uses a lot of memory
      setTimeout(() => URL.revokeObjectURL(link.href), 7000);
    },


    downloadError(show,message)
    {
      if (show)
      {
        this.errorMessage=message;
        this.$refs["referto_error"].show();
      }
      else {

        this.$refs["referto_error"].hide();
        this.errorMessage=null;
      }
    },
    pdfOnNewWindow($id,episodio,Sorgente,hash)
    {

      console.log("pdfOnNewWindow",$id);
      const _this=this;
      apiAxios("/referti/"+$id+"/downloadDirect?source="+Sorgente+"&hash="+hash)
          .then(response => {
            if (response.data==-31)
            {
              console.log("No data for file");
              return;
            }



            const base64=response.data.DownloadRefertoResult;
            const sliceSize=512;
            const byteCharacters =atob( base64);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
              const slice = byteCharacters.slice(offset, offset + sliceSize);

              const byteNumbers = new Array(slice.length);
              for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
              }

              const byteArray = new Uint8Array(byteNumbers);
              byteArrays.push(byteArray);
            }


            const file = new Blob(
                byteArrays,
                {type: 'application/pdf'});
            //Build a URL from the file
            //const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            //window.open(fileURL);
            //location.href = fileURL;
            this.downloadFile(file, "Referto_"+episodio+".pdf");

          })
          .catch(error =>{
            console.log(error);
            let message="referti.error.ERR_UNK";
            if ('response' in error)
            {
              if ('exception' in error.response.data)
              {
                const handledExc=error.response.data.exception;
                message="referti.error.ERR_"+ (handledExc.code * -1);

              }

            }
            _this.downloadError(true,message);
          });


    },

    getReferti(){
      let userdata=this.$store.getters["dateUser/UserData"];
      //Check 1
      const service1 = userdata && userdata.services && userdata.services.REFERTI ? userdata.services.REFERTI :null;
      if (service1){
        return service1;
      }
      //Check 2
      const service2 = userdata && userdata.services && userdata.services.find(s => s.name==="REFERTI");
      if (service2){
        return service2;
      }
      return null;
    },

    getPrenoting() {
      let userdata=this.$store.getters["dateUser/UserData"];
      //Check 1
      const service1 = userdata && userdata.services && userdata.services.PRENOTING ? userdata.services.PRENOTING :null;
      if (service1){
        return service1;
      }
      //Check 2
      const service2 = userdata && userdata.services && userdata.services.find(s => s.name==="PRENOTING");
      if (service2){
        return service2;
      }
      return null;
    },
    startBooking(data) {
      let userdata=this.$store.getters["dateUser/UserData"];
      console.log("startBooking",data,userdata);

      const service = this.getPrenoting();
      const token = service ? service.token : null;

      if (token == null) {
        alert("Non è possibile prenotare");
        return;
      }

      const url=process.env.VUE_APP_PRENOTING_URL + "sso?token=" + token + '&followup=' + data.idRemoto;
      console.log("url",url);

      window.location.replace(url);
    }
  },
};
</script>
